import React from 'react';
import uuid from 'uuid/v4';
import PropTypes from 'prop-types';

import StructureModel from '@Components/Results/structure/structure-model.service';
import { withStructureContext } from '@Components/Results/structure/StructureContext';
import HoverTooltip from '@Components/HoverTooltip';

import { openWith3d as openWith3dStructureDialog } from '@Containers/StructureDialog/StructureDialogAction';
import store from '@Store';
import Button from '@Components/Button';

import './StructureToolbarOptions.scss';

function StructureToolbarZoomComponent(props) {
  const { tooltipId, onOpen, structure } = props;

  const zoominStructure = () => {
    store.dispatch(openWith3dStructureDialog(uuid(), structure.molImage.structure));
  };

  const tooltipLabel = 'Zoom in';

  return (
    <div style={{ position: 'relative' }}>
      <HoverTooltip id={tooltipId} tooltip={tooltipLabel} theme="simple">
        <button
          type="button"
          className="showoverlay"
          aria-hidden="true"
          tabIndex="-1"
          onClick={() => {
            zoominStructure();
            onOpen();
          }}>
          Hi
        </button>
      </HoverTooltip>
      <Button
        buttonConfig={{
          className: 'structure-zoomin',
          type: 'link',
          size: 'sm',
          e2eName: 'zoomin',
          iconOnly: true,
          ariaLabel: 'Zoom in structure',
        }}
        iconConfig={{
          name: 'structure-zoom',
          noBorder: true,
        }}
        onClick={() => {
          zoominStructure();
          onOpen();
        }}
      />
    </div>
  );
}

StructureToolbarZoomComponent.propTypes = {
  structure: PropTypes.instanceOf(StructureModel),
  onOpen: PropTypes.func,
  tooltipId: PropTypes.string,
};

StructureToolbarZoomComponent.defaultProps = {
  onOpen: () => {},
};

const StructureToolbarZoomWithContext = withStructureContext(StructureToolbarZoomComponent);
export default StructureToolbarZoomWithContext;
